import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectGuardService } from './service/project-guard/project-guard.service';

const routes: Routes = [
  {
    path: 'autenticacao',
    loadChildren: () => import('./auth/auth.module').then(mod => mod.AuthModule)
  },
  {
    path: 'system-access',
    loadChildren: () => import('./system-access/system-access.module').then(mod => mod.SystemAccessModule)
  },
  {
    path: ':projeto',
    canActivate: [ProjectGuardService],
    canLoad: [ProjectGuardService],
    loadChildren: () => import('./internal/internal.module').then(mod => mod.InternalModule)
  },
  {
    path: '**',
    redirectTo: 'autenticacao'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
